import { request } from '@/utils/request'

// 添加意见反馈
export function feedbackSave (data) {
  return request({
    url: '/api/feedback/save',
    method: 'post',
    data
  })
}

// 意见反馈列表
export function feedbackList (params) {
  return request({
    url: '/api/feedback/list',
    method: 'get',
    params
  })
}

// 意见反馈详情
export function feedbackDetail (params) {
  return request({
    url: '/api/feedback/detail',
    method: 'get',
    params
  })
}

// 消息列表
export function messageList (params) {
  return request({
    url: '/api/message/list',
    method: 'get',
    params
  })
}

// 消息详情
export function messageDetail (params) {
  return request({
    url: '/api/message/detail',
    method: 'get',
    params
  })
}

// 消息已读
export function read (data) {
  return request({
    url: '/api/message/read',
    method: 'post',
    data
  })
}

// 消息已读全部
export function readAll (data) {
  return request({
    url: '/api/message/read-all',
    method: 'post',
    data
  })
}

// 消息未读数量
export function unReadCountGet (params) {
  return request({
    url: '/api/message/unread-count',
    method: 'get',
    params
  })
}
